import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/winterizeButton.css'
import TagManager from 'react-gtm-module'

import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom"


const tagManagerArgs = {
  gtmId: 'G-MTEKY82MMH'
}

TagManager.initialize(tagManagerArgs)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
